import { AppTeamUtil } from '../../core/app-team-util';

export class UserLoginDailyInfo
{
	Date!: Date;
	NumberOfAndroidLogins!: number;
	NumberOfIosLogins!: number;

	constructor(json?: any)
	{
		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
		this.NumberOfAndroidLogins = json.NumberOfAndroidLogins;
		this.NumberOfIosLogins = json.NumberOfIosLogins;
	}
}

export class UserLoginReportData
{
	DailyInfo!: UserLoginDailyInfo[];
	UniqueUserLogins!: number;

	constructor(json?: any)
	{
		this.UniqueUserLogins = json.UniqueUserLogins;
		this.DailyInfo = json.DailyInfo.map((itemJson: any) => new UserLoginDailyInfo(itemJson));
	}
}
